var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box-main" }, [
    _c("div", { staticClass: "main" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "main-center" },
        [
          _c(
            "v-row",
            { staticClass: "tabs-demo__size" },
            [
              _c(
                "v-col",
                { attrs: { span: 22 } },
                [
                  _c(
                    "v-tabs",
                    {
                      attrs: { size: "S", name: "tabs-s-card", type: "card" },
                      model: {
                        value: _vm.activeName,
                        callback: function ($$v) {
                          _vm.activeName = $$v
                        },
                        expression: "activeName",
                      },
                    },
                    [
                      _c(
                        "v-tab-pane",
                        { attrs: { label: "解析器", value: "1" } },
                        [_c("ParseList")],
                        1
                      ),
                      _c(
                        "v-tab-pane",
                        { attrs: { label: "数据源", value: "2" } },
                        [_c("SourceList")],
                        1
                      ),
                      _c(
                        "v-tab-pane",
                        { attrs: { label: "数据目的", value: "3" } },
                        [_c("PurposeList")],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticClass: "main-title" }, [_vm._v("规则引擎")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }